import { formatCurrency, transformDateToLocalDateString } from "helpers";
import {
  DEFAULT_EXPENSE_TYPE_ICON,
  EXPENSE_TYPE_ICONS,
} from "services/api/fleet/vehicles/expenses/consts";
import { FleetVehicleExpenseRow } from "services/api/fleet/vehicles/expenses/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { PictureIcon } from "ui/components/Pictures";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Tooltip from "ui/components/Tooltip/Tooltip";
import InvoiceIncomingCell from "ui/components/Table/TableSearch/components/Cells/InvoiceIncomingCell";

export const FLEET_VEHICLE_EXPENSE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "",
      key: "expense_icon",
      field: "",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      // Ikona prati vrstu troška — ista koju vrsta nosi i u čarobnjaku unosa.
      render: (row: FleetVehicleExpenseRow) => (
        <TableIcon
          icon={
            EXPENSE_TYPE_ICONS[row.expenseTypeCode ?? ""] ??
            DEFAULT_EXPENSE_TYPE_ICON
          }
        />
      ),
    },
    {
      title: "",
      key: "expense_documents",
      field: "",
      alwaysVisible: true,
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        if (!row.childRows || row.childRows.length === 0) return null;
        // Klik na ikonu otvara priloženi dokument u novom tabu.
        return (
          <PictureIcon
            size="sm"
            items={row.childRows.map((upload) => ({
              id: upload.id,
              url: upload.url,
              fileName: upload.originalFileName,
              tooltip: upload.originalFileName,
            }))}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.type",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        return (
          <Badge
            text={row.expenseTypeName ?? "-"}
            variant="info"
            height="small"
            showDot
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        return (
          <div>
            <div className="font-medium text-slate-900">
              {row.name}
            </div>
          
          </div>
        );
      },
    },
     {
      title: "admin.fleet.vehicle.expense.search.description",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        return (
          <div>
            <div className="text-sm text-slate-600 max-w-[800px] overflow-hidden text-ellipsis line-clamp-1">
              {row.description}
            </div>
           
          </div>
        );
      },
    },
    {
      title: "Ulazni račun",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        if (!row.invoiceIncoming) return <div className="text-sm text-slate-400">-</div>;
        return (
          <InvoiceIncomingCell
            invoice={row.invoiceIncoming}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.expensedate",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        return <div className="text-sm">{transformDateToLocalDateString(row.expenseDate)}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.amount",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => (
        <Tooltip
          decorate={<span className="text-sm font-medium">{formatCurrency.format(row.amount ?? 0)}</span>}
          position="bottom-right"
          size="medium"
        >
          <div className="min-w-[220px]">
            <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Pregled iznosa</div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">Iznos bez PDV-a</span>
              <span className="font-medium">{formatCurrency.format(row.amount ?? 0)}</span>
            </div>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-slate-300">PDV</span>
              <span className="font-medium">{formatCurrency.format(row.taxAmount ?? 0)}</span>
            </div>
            <div className="border-t border-slate-600 my-2"></div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-300">Ukupno</span>
              <span className="font-bold text-green-400">{formatCurrency.format((row.amount ?? 0) + (row.taxAmount ?? 0))}</span>
            </div>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleExpenseRow) => {
        return (
          <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => onDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];


export const FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.expense.uploads.search.name",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.string,
    },
  ];
